import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getTodayPosts } from "../api/getTodayPosts";

class TodayContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || {};
    const posts = (result && result.posts) || [];
    return render({ posts, loading, failure });
  };
}

TodayContainer.defaultProps = {};
export default CreateContainer(getTodayPosts, TodayContainer);
